import api from "../config/api";

export const userLogin = async(FormData) => {
    const res = await api.post(`/customer/login/`, FormData)
    return res.data;
}

export const userSignUp = async(FormData) => {
    const res = await api.post(`/customer/`, FormData)
    return res.data;
}